import React from "react";
import { useTranslation } from "react-i18next";

// Components
import Navbar from "../containers/Home/Navbar";
import BackToEditor from "../components/UI/BackToEditor";
import EnContent from "../containers/Terms/EnContent";
import RuContent from "../containers/Terms/RuContent";

const languages = {
  en: EnContent,
  ru: RuContent,
};

const Terms = () => {
  const { i18n } = useTranslation();
  const LocalContent = languages[i18n.language] || EnContent;

  return (
    <>
      <Navbar />
      <BackToEditor />
      <div className="page">
        <div className="page-content">
          <LocalContent />
        </div>
      </div>
    </>
  );
};

export default Terms;
